import React from 'react';
import {useFormContext} from 'react-hook-form';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {ControllerWrapper} from '@/components/common';
import {SoopInputBox} from '@soop-ui/soop-ui';
import {useFormLabels} from '@/hooks/help/useFormLabels';
import {FORM_FIELDS} from '@/constants/help/index';
import {useFormClear} from '@/hooks/help/useFormClear';
import {useFormKeyHandler} from '@/hooks/help/useFormKeyHandler';

const TITLE_ERROR_MESSAGE = '제목을 입력해 주세요.';
const TITLE_MIN_LENGTH_ERROR_MESSAGE = '제목을 5자 이상 입력해 주세요.';
const TITLE_MAX_LENGTH_ERROR_MESSAGE = '제목을 100자 이하로 입력해 주세요.';

const Title = () => {
  const {
    formState: {errors},
  } = useFormContext();
  const {title} = useFormLabels();
  const {handleClear} = useFormClear();
  const {handleFormKeyDown} = useFormKeyHandler();
  const onClear = () => handleClear(FORM_FIELDS.TITLE, {shouldFocus: true});

  return (
    <div className={`${styles.section} ${styles.titleSection}`}>
      <label className={styles.label}>
        {`${title} 내용`} <em>*</em>
      </label>
      <ControllerWrapper
        component={SoopInputBox}
        needsBlurWrapper={true}
        clearable={true}
        onClear={onClear}
        size='44'
        name={FORM_FIELDS.TITLE}
        rules={{
          required: TITLE_ERROR_MESSAGE,
          minLength: {
            value: 5,
            message: TITLE_MIN_LENGTH_ERROR_MESSAGE,
          },
          maxLength: {
            value: 100,
            message: TITLE_MAX_LENGTH_ERROR_MESSAGE,
          },
        }}
        placeholder='제목 입력'
        error={!!errors.title}
        onKeyDown={(e) => {
          handleFormKeyDown(e);
        }}
      />
    </div>
  );
};

export default Title;
